const model = {
    b_type_of_trafficking: '',
    b_confirmed: '',
    b_confirmed_comment: '',
    b_confirmation_source: '',
    b_confirmation_LE: false,
    b_confirmation_LE_date: '',
    b_confirmation_LE_comment: '',
    b_confirmation_Victim: false,
    b_confirmation_Victim_date: '',
    b_confirmation_Victim_comment: '',
    b_confirmation_CPS: false,
    b_confirmation_CPS_date: '',
    b_confirmation_CPS_comment: '',
    b_confirmation_Med: false,
    b_confirmation_Med_date: '',
    b_confirmation_Med_comment: '',
    b_confirmation_Expert: false,
    b_confirmation_Expert_date: '',
    b_confirmation_Expert_comment: '',
    b_confirmation_Other: false,
    b_confirmation_Other_date: '',
    b_confirmation_Other_comment: '',
    b_location_of_trafficking: '',
    b_location_of_trafficking_multiple_one: '',
    b_location_of_trafficking_multiple_two: '',
    b_location_of_trafficking_out_state: '',
    b_location_of_trafficking_out_state_city: '',
    b_location_of_trafficking_out_country: '',
    b_location_of_origin: '',
    b_location_of_origin_out_state: '',
    b_location_of_origin_out_state_city: '',
    b_location_of_origin_country: '',
    i_s_commercial_sex_exploitation_of_child: false,
    i_s_forced_commercial_sex_exploitation: false,
    i_s_familial_facilitated: false,
    i_s_gang_facilitated: false,
    i_s_minor_engaged_in_survival_sex: false,
    /* means of labor trafficking */
    i_l_domestic_servitude: false,
    i_l_familial_facilitated: false,
    i_l_gang_facilitated: false,
    i_l_industry_related: false,
    i_l_trafficked_industry: '',
    i_l_trafficked_industry_otherText: '',
    b_confirmed_otherText: '',
    b_mdt_decided_date: '',
    b_mdt_confirmed_date: '',
    b_mdt_rejected_reason: '',
    b_mdt_rejected_comment: '',
    b_mdt_status: ''
}

export { model }



// WEBPACK FOOTER //
// ./src/api/models/victimInfo.js